'use client';
import { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Image from 'next/image';
import { useAuth } from '@/contexts/AuthContext';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const pathname = usePathname();
  const { user, loading } = useAuth();

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <nav className="container flex h-16 items-center justify-between px-6">
        {/* Logo */}
        <Link href="/homepage" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
          <Image
            src="/assets/images/Untitled_design-1770776842500.png"
            alt="Airframe Powerplant Prep Logo"
            width={40}
            height={40}
            className="object-contain" />

          <span className="text-lg sm:text-xl font-bold text-foreground truncate max-w-[150px] sm:max-w-none">Airframe Powerplant Prep</span>
        </Link>

        {/* CTA Button - Only show when user is NOT logged in */}
        {!loading && !user &&
        <div className="flex items-center gap-4">
            <Link
            href="/sign-up-login"
            className="inline-flex items-center justify-center py-2 px-3 sm:px-4 text-xs sm:text-sm font-semibold text-primary-foreground bg-primary rounded-full hover:bg-primary/90 transition-colors">

              Sign In
            </Link>
          </div>
        }
      </nav>
    </header>);

};

export default Header;